import { lazy } from 'react';

// Types
import { PaymentOptionUnavailableProps as LazyComponentProps } from './PaymentOptionUnavailable.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "paymentOptionUnavailable" */ './PaymentOptionUnavailable')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PaymentOptionUnavailable');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PaymentOptionUnavailable };
